<template>
	<div class="row px-4">
		<div class="row justify-content-end mb-5">
			<div class="col-sm-2">
				<BaseButton
					class="btn form-control btn-danger"
					label="Block all users"
					@on:Click="changeStatus('all', 'false')"
				/>
			</div>
			<div v-if="blockedUserCount.count > 3" class="col-sm-2">
				<BaseButton
					class="btn form-control btn-success"
					label="Unblock all users"
					@on:Click="changeStatus('all', 'true')"
				/>
			</div>
		</div>
		<div class="table-wrapper">
			<table-lite
				:is-loading="table.isLoading"
				:columns="table.columns"
				:rows="table.rows"
				:total="table.totalRecordCount"
				:sortable="table.sortable"
				:messages="table.messages"
				@do-search="doSearch"
				@is-finished="tableLoadingFinish"
				:pageOptions="[ { value: 10, text: 10 }, { value: 25, text: 25 }, { value: 50, text: 50 }, { value: 100, text: 100 }, { value: 500, text: 500 }, { value: 1000, text: 1000 } ]"
			/>
		</div>
	</div>
</template>
<script>
	import { reactive, inject } from "vue";
	import TableLite from "vue3-table-lite";
	import toast from "@/config/toast";
	import API from "@/config/api";
	import BaseButton from "./BaseButton.vue";

	export default {
		name: "UserTable",
		components: {
			TableLite,
			BaseButton,
		},
		setup: () => {
			const store = inject("store");
			const masterStore = inject("masterStore");

			const roles = reactive({
				env_admin: process.env_VUE_APP_USER_ADMIN,
			});
			const table = reactive({
				isLoading: false,
				columns: [
					{
						label: "Name",
						field: "",
						width: "15%",
						sortable: true,
						display: function (row) {
							return `<div>
	                           <b>${row.firstName} ${row.lastName}</b></div>`;
						},
					},
					{
						label: "Email",
						field: "email",
						width: "15%",
						sortable: false,
					},
					{
						label: "Phone",
						field: "phone",
						width: "10%",
						sortable: false,
					},
					{
						label: "Assigned Area",
						field: "area",
						width: "10%",
						sortable: true,
					},
					{
						label: "Enquiry Target",
						field: "enquiryTarget",
						width: "10%",
						sortable: false,
					},
					{
						label: "Booking Target",
						field: "bookingTarget",
						width: "10%",
						sortable: false,
					},
					{
						label: "Role",
						field: "",
						width: "10%",
						sortable: false,
						display: function (row) {
							return `${row.role[0].replace(/_/g, " ")}`;
						},
					},
					{
						label: "Active Status",
						field: "activeStatus",
						width: "5%",
						sortable: false,
						display: function (row) {
							return `<div class="is-rows-el activeStatus ${
								row.activeStatus ? "bg-trans-green" : "bg-trans-red"
							}"  >${row.activeStatus ? "Online" : "Offline"}</div>`;
						},
					},
					{
						label: "Status",
						field: "isUserBlocked",
						width: "5%",
						sortable: false,
						display: function (row) {
							return `<button type="button" data-id="
	                           ${row._id}
	                           " data-status="${
																row.isUserBlocked
															}" class="is-rows-el quick-btn btn btn-sm ${
								row.isUserBlocked ? "btn-success" : "btn-danger"
							} ${row.role[0] === roles.env_admin ? "disabled" : ""}"  >${
								row.isUserBlocked ? "Unblock" : "Block"
							}</button>`;
						},
					},
					{
						label: "Actions",
						field: "",
						width: "10%",
						sortable: false,
						display: function (row) {
							return `<div class="d-flex justify-content-around align-items-center">
	                               <button type="button" data-id="${row._id}"
	                               data-action="show"
	                               class="is-rows-el action-btn btn btn-sm btn-success"><i class="bi bi-eye"></i></button>
	                               <button type="button" data-id="${row._id}"
	                                data-action="edit"
	                               class="is-rows-el action-btn btn btn-sm btn-warning">
	                               <i class="bi bi-pencil-square"></i>
	                               </button>
	                               
	                               </div>`;
						},
					},
				],
				rows: [],
				totalRecordCount: 10,
				sortable: {
					sort: "asc",
				},
			});

			const blockedUserCount = reactive({ count: 0 });

			const setBlockedCount = () => {
				let count = table.rows.filter((row) => row.isUserBlocked);
				if (count.length > 3) {
					blockedUserCount.count = count.length;
				}
			};
			const getUsers = async () => {
				table.isLoading = true;
				try {
					const { data } = await API.privateRequest.get("users");
					if (!data.data.length) return;
					table.rows = data.data;
					table.totalRecordCount = data.count;
					table.isLoading = false;
					setBlockedCount();
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (
						err?.response?.status >= 400 &&
						err?.response?.status < 422
					) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}
					console.log(err);
					console.log("error", message);
				}
			};

			getUsers();

			const doSearch = async (offset, limit, order, sort) => {
				try {
					table.isLoading = true;
					let url = "";
					if (offset) url = `${url}offset=${offset}&`;
					if (limit) url = `${url}limit=${limit}&`;
					if (order) url = `${url}order=${order}&`;
					if (sort) url = `${url}sort=${sort}`;

					const response = await API.privateRequest.get(`users?dt=true&${url}`);

					table.rows = response?.data.data;
					table.totalRecordCount = response?.data?.count;
					table.sortable.order = order;
					table.sortable.sort = sort;
					table.isLoading = false;
				} catch (err) {
					alert(err);
				}
			};

			const tableLoadingFinish = (elements) => {
				// console.log(document.querySelector(".quick-btn"));
				table.isLoading = false;

				Array.prototype.forEach.call(elements, function (element) {
					// if (element.classList.contains("name-btn")) {
					// 	element.addEventListener("click", function () {
					// 		console.log(this.dataset.id + " name-btn click!!");
					// 	});
					// }
					if (element.classList.contains("quick-btn")) {
						element.addEventListener("click", function () {
							changeStatus(this.dataset.id, this.dataset.status);
						});
					}
					if (element.classList.contains("action-btn")) {
						element.addEventListener("click", function () {
							changeComponent(this.dataset.id, this.dataset.action);
						});
					}
				});
			};

			const changeStatus = async (id, status) => {
				const bool = status === "false" ? false : true;

				try {
					await API.privateRequest.patch(`users/${id.trim()}`, {
						isUserBlocked: !bool,
					});
					toast.success(
						`${id === "all" ? "All Users" : "User"} ${
							!bool ? "Blocked" : "Unblocked"
						}`,
					);
					if (id === "all" && bool) {
						blockedUserCount.count = 0;
					}
					table.rows = table.rows.map((row) => {
						if (id !== "all" && row._id === id.trim()) {
							row.isUserBlocked = !row.isUserBlocked;
						} else if (id === "all" && bool) {
							row.isUserBlocked = false;
						} else if (id === "all" && !bool && row.role[0] !== "ADMIN") {
							row.isUserBlocked = true;
						}
						return row;
					});
					setBlockedCount();
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (
						err?.response?.status >= 400 &&
						err?.response?.status < 422
					) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
				}
			};

			const changeComponent = (id, action) => {
				id = id.trim();
				action = action.trim();
				try {
					if (action === "delete") {
						masterStore.methods.setId("delete", id);
						table.rows = table.rows.filter((row) => row._id !== id);
					} else if (action === "show") {
						masterStore.methods.changeComponent("view");
						masterStore.methods.changeData(
							table.rows.filter((row) => row._id === id)[0],
						);
					} else if (action === "edit") {
						masterStore.methods.setId("edit", id);
						masterStore.methods.changeData(
							table.rows.filter((row) => row._id === id)[0],
						);
						masterStore.methods.changeComponent("edit");
					}
				} catch (err) {
					console.log("error in UserTable actions");
				}
			};

			return {
				table,
				blockedUserCount,
				doSearch,
				changeStatus,
				tableLoadingFinish,
			};
		},
	};
</script>
<style scoped>
	::v-deep(.vtl-paging-info) {
		font-size: 0.8rem;
	}
	::v-deep(.vtl-paging-count-label),
	::v-deep(.vtl-paging-page-label) {
		padding-left: 1rem;
		padding-right: 0.4rem;
		font-size: 0.8rem;
	}
	::v-deep(.vtl-paging-pagination-div) {
		padding-bottom: 1rem;
		font-size: 0.8rem;
	}
	::v-deep(.vtl-tbody),
	::v-deep(.vtl-thead-th) {
		font-size: 0.8rem;
	}

	::v-deep(.vtl-tbody-td > div) {
		height: 100%;
	}

	::v-deep(.vtl-tbody-tr .vtl-tbody-td) {
		border: none;
	}
	::v-deep(.vtl-thead-tr) {
		border-bottom: 1px groove rgba(168, 167, 167, 0.442);
	}
	::v-deep(.vtl-thead-tr .vtl-thead-th) {
		background: rgb(255, 255, 255);
		color: #000;
		border: none;
	}
	::v-deep(.vtl-card) {
		padding: 0;
		border-radius: 20px;
		overflow: hidden;
	}
	::v-deep(.vtl-paging) {
		padding: 0 1rem;
	}
	.vtl-thead-td::nth-child(5) {
		background: red;
	}
	::v-deep(.action-dot) {
		height: 8px;
		width: 8px;
		border-radius: 50%;
		background: red;
		position: relative;
	}
	::v-deep(.action-dot::before) {
		content: "";
		position: absolute;
		left: -120%;
		height: inherit;
		width: inherit;
		border-radius: inherit;
		background: green;
		z-index: 0;
	}
	::v-deep(.action-dot::after) {
		content: "";
		position: absolute;
		right: -120%;
		height: inherit;
		width: inherit;
		border-radius: inherit;
		background: yellowgreen;
		z-index: 0;
	}
	::v-deep(.actions) {
		display: none;
		justify-content: space-between;
		align-items: center;
		position: absolute;
		border-radius: 10px;
		background: #e9642be4;
		height: auto;
		z-index: 50;
		left: -120%;
		min-width: 200px;
		padding: 0.6rem 1rem;
		transition: 0.8s ease-in-out;
	}
	/* ::v-deep(.actions:after) {
		content: "";
		top: 50%;
		right: 50%;
		transform: translateY(-50%) rotateZ(45deg);
		height: 20px;
		width: 20px;
		background: inherit;
	} */
	::v-deep(.action-container) {
		height: 100%;
		cursor: pointer;
		transition: 0.8s ease-in-out;
	}
	::v-deep(.action-container:hover .actions) {
		display: flex;
		transition: 0.8s ease-in-out;
	}

	/* we will explain what these classes do next! */
	.v-enter-active,
	.v-leave-active {
		transform-origin: 1.8rem 0;
		transition: transform 0.5s ease-in-out;
	}

	.v-enter-from,
	.v-leave-to {
		transform: scale(0);
		transform-origin: 1.8rem 0;
	}
	::v-deep(.activeStatus) {
		padding: 2px 3px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	::v-deep(.bg-trans-red) {
		background: rgba(255, 0, 0, 0.266);
		border-radius: 4px;
	}
	::v-deep(.bg-trans-green) {
		background: rgba(38, 255, 0, 0.266);
		border-radius: 4px;
	}
</style>
